@if (report() && selectedLesson()) {
	<div>
		<div class="pagination">
			<span>Lesson:</span>
			@if (report()!.lessons.length > 0) {
				<nz-pagination
					[nzPageIndex]="selectedLessonIndex()"
					[nzPageSize]="1"
					[nzTotal]="report()!.lessons.length"
					(nzPageIndexChange)="selectLesson($event)"
				></nz-pagination>
			}
		</div>

		<div class="class-summary">
			<div class="title">
				<span class="bold">Class Overview</span>
				<span class="sub-title">{{ selectedLesson()!.lesson.lesson_text[0].name }}</span>
			</div>
			<div class="activity-summary-wrapper">
				@for (activity of selectedLesson()!.activities; track activity; let i = $index) {
					<div class="activity-summary" [style.width]="100 / selectedLesson()!.activities.length + '%'">
						<div class="activity-summary-count" nz-tooltip="In Progress + Completed count">
							{{ activity.in_progress + activity.completed }}
							<span nz-icon nzType="team" nzTheme="outline"></span>
						</div>
						<div class="activity-summary-graph">
							<div
								class="activity-summary-graph-in-progress"
								[style.height]="activity.in_progress * 6 + 'px'"
							></div>
							<div
								class="activity-summary-graph-completed"
								[ngClass]="{ 'radius-top': activity.in_progress === 0 }"
								[style.height]="activity.completed * 6 + 'px'"
							></div>
						</div>
						<div class="activity-summary-order" nz-tooltip="Activity order">{{ i + 1 }}</div>
					</div>
				}
			</div>
			<div class="class-summary-key">
				<div class="completed">
					<div class="color-box"></div>
					Completed
				</div>
				<div class="in-progress">
					<div class="color-box"></div>
					In Progress
				</div>
			</div>
		</div>

		<div class="student-summary">
			<div class="title">
				<span class="bold">Student Overview</span>
				<span class="sub-title">Click to See Details</span>
			</div>
			<table>
				<tr>
					<th>Student</th>
					<th>Activity Graph</th>
					<th>Completed</th>
					<th>In Progress</th>
					<th>Accuracy</th>
				</tr>
				@for (student of selectedLesson()!.students; track student) {
					<tr>
						<td class="student fade-in-with-delay" (click)="selectStudent(student.studentUuid)">
							{{ student.studentUuid | displayName: 'user' | async }}
						</td>
						<td>
							<div class="activity-graph">
								<div class="activity-graph-chunks">
									@for (item of range(student.totalActivitiesInLesson); track $index) {
										<div
											class="activity-status-chunk"
											[class.in-progress]="
												student.activityStatus[$index] &&
												TakeStatus.IN_PROGRESS === student.activityStatus[$index]
											"
											[class.completed]="
												student.activityStatus[$index] &&
												TakeStatus.COMPLETED === student.activityStatus[$index]
											"
										></div>
									}
								</div>
								<div class="activity-graph-progress">
									{{ student.totalInProgressActivities }} / {{ student.totalActivitiesInLesson }}
								</div>
							</div>
						</td>
						<td class="center">
							{{ student.totalCompletedActivities }} / {{ student.totalActivitiesInLesson }}
						</td>
						<td class="center">
							{{ student.totalInProgressActivities }} / {{ student.totalActivitiesInLesson }}
						</td>
						<td class="center">{{ student.score }}%</td>
					</tr>
				}
			</table>
		</div>
	</div>
}
